import { render, staticRenderFns } from "./LandingHeader.vue?vue&type=template&id=83c24602&scoped=true&"
import script from "./LandingHeader.vue?vue&type=script&lang=js&"
export * from "./LandingHeader.vue?vue&type=script&lang=js&"
import style0 from "./LandingHeader.vue?vue&type=style&index=0&id=83c24602&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83c24602",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LandingLogo: require('/home/circleci/repo/components/landing/elements/LandingLogo.vue').default,LandingMenu: require('/home/circleci/repo/components/landing/LandingMenu.vue').default})
